import React from 'react';
import { Layout } from '../components/layout';

export const PrivacyPage: React.FC = () => {

  return (
    <Layout showNav={false}>
      <div className="px-4 py-4">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-lg font-bold text-text-primary">
            Политика конфиденциальности сервиса «XPlay Store»
          </h1>
        </div>

        {/* Content */}
        <div className="space-y-5 text-sm text-text-secondary leading-relaxed">
          <section>
            <h2 className="text-base font-semibold text-text-primary mb-2">1. Какие данные мы собираем</h2>
            <ul className="list-disc list-inside space-y-1 ml-1">
              <li>Имя, email, телефон (если указывается).</li>
              <li>Платежные данные (через защищенные платежные шлюзы).</li>
              <li>IP-адрес, тип устройства, операционная система.</li>
              <li>История покупок, отзывы.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-semibold text-text-primary mb-2">2. Регистрация и аккаунт</h2>
            <ul className="list-disc list-inside space-y-1 ml-1">
              <li>Данные используются для регистрации и поддержки аккаунта.</li>
              <li>Для предоставления персонализированных рекомендаций.</li>
              <li>Для соблюдения требований законодательства.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-semibold text-text-primary mb-2">3. Покупки и возвраты</h2>
            <ul className="list-disc list-inside space-y-1 ml-1">
              <li>Обмен данными осуществляется с платежными системами (только необходимые сведения).</li>
              <li>Обмен данными с государственными органами — только в случаях, предусмотренных законом.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-semibold text-text-primary mb-2">4. Безопасность</h2>
            <ul className="list-disc list-inside space-y-1 ml-1">
              <li>Данные хранятся в зашифрованном виде.</li>
              <li>Используются современные меры защиты (SSL, шифрование, ограничение доступа).</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-semibold text-text-primary mb-2">5. Cookie</h2>
            <ul className="list-disc list-inside space-y-1 ml-1">
              <li>Используем cookies для авторизации и аналитики.</li>
              <li>Пользователь может отключить cookies в браузере, но это может ограничить работу сервиса.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-semibold text-text-primary mb-2">6. Ваши права</h2>
            <ul className="list-disc list-inside space-y-1 ml-1">
              <li>Пользователь вправе узнать, какие данные мы храним.</li>
              <li>Пользователь может запросить удаление или изменение данных.</li>
              <li>Пользователь вправе отказаться от маркетинговой рассылки.</li>
            </ul>
          </section>
        </div>
      </div>
    </Layout>
  );
};
